import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from "react-router-dom";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";

const Gridorderlist = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const botData = location.state;
  const botIdentifier = botData?.id || botData?._id || null;
  // console.log(botData, "botData");
  const path = usercalls();
  const [botDetails, setBotDetails] = useState({});
  const [gridOrders, setGridOrders] = useState([]);
  const [botEnabled, setBotEnabled] = useState(botData?.is_enabled || false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [orderTab, setOrderTab] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const formatFixedValue = (value, digits = 5) => {
    const num = Number(value);
    return Number.isFinite(num) ? parseFloat(num.toFixed(digits)) : "---";
  };

  const requiredQuoteBalance =
    Number(botDetails?.quantity_per_grid) * Number(botDetails?.grids_quantity);
  const requiredBaseBalance =
    requiredQuoteBalance / Number(botDetails?.current_price);

  const getGridOrders = async () => {
    if (!botIdentifier) {
      setGridOrders([]);
      return;
    }

    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-grid-orders`;
      const payload = { id: botIdentifier };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const orderResult = result?.result || result;
        const gridLinesOrders = Array.isArray(orderResult?.grid_lines_orders)
          ? orderResult.grid_lines_orders
          : [];
        const balancingOrders = Array.isArray(orderResult?.balancing_orders)
          ? orderResult.balancing_orders
          : [];
        // Combine both arrays and add a type field
        const allOrders = [
          ...gridLinesOrders.map((order) => ({
            ...order,
            orderCategory: "Grid Line",
          })),
          ...balancingOrders.map((order) => ({
            ...order,
            updated_at: order.updated_at || order.update_at || null,
            orderCategory: "Balancing",
          })),
        ].sort((firstOrder, secondOrder) => {
          const firstDate =
            new Date(
              firstOrder.updated_at ||
                firstOrder.update_at ||
                firstOrder.created_at ||
                0,
            ).getTime() || 0;
          const secondDate =
            new Date(
              secondOrder.updated_at ||
                secondOrder.update_at ||
                secondOrder.created_at ||
                0,
            ).getTime() || 0;

          return secondDate - firstDate;
        });
        setGridOrders(allOrders);
      } else {
        setGridOrders([]);
      }
    } catch (err) {
      setGridOrders([]);
    } finally {
      setTradeLoading(false);
    }
  };

  useEffect(() => {
    if (!botIdentifier) return;

    getGridBotDetails();
    getGridOrders();
  }, [botIdentifier]);

  useEffect(() => {
    setBotEnabled(Boolean(botDetails?.is_enabled));
  }, [botDetails]);

  const getGridBotDetails = async () => {
    if (!botIdentifier) {
      setBotDetails({});
      return;
    }

    try {
      const url = `${consts.BackendUrl}/bots/get-grid-botlist`;
      const payload = { id: botIdentifier };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setBotDetails(result.result);
      } else {
        setBotDetails({});
      }
    } catch (err) {
      setBotDetails({});
    }
  };

  const handleToggleBotStatus = async (nextEnabled) => {
    if (!botIdentifier) {
      toast.error("Bot id is missing");
      return;
    }

    const type = nextEnabled ? "enable" : "disable";
    setToggleLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/toggle-grid-bot`;
      const payload = { id: botIdentifier, type };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || `Bot ${type}d successfully`);
        setBotEnabled(nextEnabled);
        setTimeout(() => {
          getGridBotDetails();
          getGridOrders();
        }, 1000);
      } else {
        toast.error(result?.message || `Failed to ${type} bot`);
      }
    } catch (err) {
      toast.error(`Failed to ${type} bot`);
    } finally {
      setToggleLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeOrderTab = (newValue) => {
    setOrderTab(newValue);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const gridLineOrders = gridOrders.filter(
    (order) => order.orderCategory === "Grid Line",
  );
  const balancingOrders = gridOrders.filter(
    (order) => order.orderCategory === "Balancing",
  );
  const selectedOrders = orderTab === 0 ? gridLineOrders : balancingOrders;
  const activePaginated = selectedOrders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const formatDate = (dateString) => {
    if (!dateString) return "---";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="bot_container contain-width mb-20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Name</h4>
                  <div>{botDetails?.name || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Pair</h4>
                  <div>{botDetails?.pair || "-"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Status</h4>
                  <div>{botEnabled ? "Enabled" : "Disabled"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Grids</h4>
                  <div>{botDetails?.grids_quantity || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Grid Type</h4>
                  <div>
                    {botDetails?.grid_type === "arithmetic"
                      ? "Arithmetic"
                      : botDetails?.grid_type === "geometric"
                        ? "Geometric"
                        : botDetails?.grid_type}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Profit Currency</h4>
                  <div>
                    {botDetails?.order_currency_type === "base"
                      ? "Base"
                      : botDetails?.order_currency_type === "quote"
                        ? "Quote"
                        : botDetails?.order_currency_type || "---"}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Current Price</h4>
                  <div>
                    {botDetails?.current_price
                      ? botDetails.current_price
                      : "---"}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Current Profit</h4>
                  <div>
                    {botDetails?.current_profit
                      ? formatFixedValue(botDetails.current_profit) + " USD"
                      : "---"}
                  </div>
                  {/* <div>{botDetails?.current_profit_loss || "---"} USD</div> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Required Balance</h4>
                  <div
                    className="display-1"
                    style={{ flexDirection: "column", alignItems: "end" }}
                  >
                    <div className="d-flex">
                      {formatFixedValue(requiredQuoteBalance)}{" "}
                      {botDetails?.pair?.split("_")[0] || "Quote"}
                    </div>
                    <div className="fl">
                      {formatFixedValue(requiredBaseBalance)}{" "}
                      {botDetails?.pair?.split("_")[1] || "Base"}
                    </div>
                  </div>
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Total Profit</h4>
                  <div>
                    {botDetails?.total_profit ? botDetails.total_profit : "---"}
                  </div>
                </div>
              </Grid> */}

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className="flexend mb-20">
                  <div className="bot_comman_btn">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={botEnabled}
                          onChange={(e) =>
                            handleToggleBotStatus(e.target.checked)
                          }
                          color="primary"
                          disabled={toggleLoading}
                        />
                      }
                      label={botEnabled ? "Enabled" : "Disabled"}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-20">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="custom_table box_bdr mt-20">
            <div className="h_flx">
              <h3>Order List</h3>
            </div>

            <div className="display-1 flex-wrap gap-10 mb-20">
              <h3
                onClick={() => handleChangeOrderTab(0)}
                className={orderTab === 0 ? "active assetTab" : "assetTab"}
              >
                Grid Orders ({gridLineOrders.length})
              </h3>

              <h3
                onClick={() => handleChangeOrderTab(1)}
                className={orderTab === 1 ? "active assetTab" : "assetTab"}
              >
                Balancing Orders ({balancingOrders.length})
              </h3>
            </div>

            <TableContainer sx={{ marginBottom: "10px" }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Order Time</TableCell>
                    <TableCell>Pair</TableCell>
                    <TableCell>Side</TableCell>
                    <TableCell>Price (Rate)</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Remaining</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Avg Price</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tradeLoading ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <div className="inline-loader">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : activePaginated?.length > 0 ? (
                    activePaginated.map((row, i) => (
                      <TableRow key={i} className="tr_row">
                        <TableCell>{formatDate(row.created_at)}</TableCell>
                        <TableCell>
                          {row.pair || botDetails?.pair || "---"}
                        </TableCell>
                        <TableCell
                          style={{
                            color:
                              row.order_type === "BUY" ? "#00C853" : "#FF5252",
                          }}
                        >
                          {row.order_type || "---"}
                        </TableCell>
                        <TableCell>{row.rate || "---"}</TableCell>
                        <TableCell>{row.quantity || "---"}</TableCell>
                        <TableCell>{row.quantity_remaining || "---"}</TableCell>
                        <TableCell>
                          {row.total && !isNaN(row.total)
                            ? parseFloat(Number(row.total).toFixed(5))
                            : "0"}
                        </TableCell>
                        <TableCell>{row.average_price || "---"}</TableCell>
                        <TableCell>{row.order_id || "---"}</TableCell>
                        <TableCell>{row.status_string || "---"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        {orderTab === 0
                          ? "No Grid Orders Found"
                          : "No Balancing Orders Found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={selectedOrders.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[10]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Gridorderlist;
